// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__tYO2A","Content":"Layout_Content__3gXa2"};